import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface FormSectionProps {
  action?: ReactNode
  children: ReactNode
  className?: string
  description?: string
  title?: string
  titleExtra?: ReactNode
}

export function FormSection({
  action,
  children,
  className,
  description,
  title,
  titleExtra,
}: FormSectionProps) {
  return (
    <section
      className={cn(
        'rounded-lg border border-[var(--color-panel-border)] bg-white p-4 shadow-[var(--shadow-panel-subtle)]',
        className,
      )}
      data-form-section
    >
      {title || description || action ? (
        <div className="mb-4 flex items-start justify-between gap-4">
          <div className="min-w-0">
            {title ? (
              <div className="inline-flex w-fit items-center gap-1">
                <h3 className="text-sm font-semibold text-[var(--color-text)]" title={title}>
                  {title}
                </h3>
                {titleExtra}
              </div>
            ) : null}
            {description ? (
              <p className="mt-1 text-xs text-[var(--color-text-subtle)]">{description}</p>
            ) : null}
          </div>
          {action ? <div className="shrink-0">{action}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  )
}
